import React from 'react'
import { useNavigate } from 'react-router-dom'

const Benefits = ({ data, sucessDriven, devServices }) => {

    const navigate = useNavigate()

    const handleClick = (i, link) => {

        if (link) {
            navigate(link)
        }

        if (!sucessDriven) {
            if (i === 0) {
                navigate('/pricing')
            }
            else if (i === 1) {
                window.scrollTo(0, 0)
            }
            else if (i === 2 || i === 3) {
                navigate('/hire-react-developer')
            }
            else if (i === 4) {
                navigate('/#review')
            }
        }

        if (!link) {
            window.scrollTo(0, 0)
        }
    }

    return (
        <div>
            <div className='max-w-screen-2xl mx-auto py-5 md:py-8 w-[87%] md:w-full md:px-12'>
                {data.title1Span ? (
                    <div>
                        <h1
                            className='text-xl dark:text-white md:text-2xl font-bold text-center'
                        >
                            {data.title1} <span className='text-red-500'>{data.title1Span}</span> <br /> {data.title2}
                        </h1>
                    </div>
                ) : (

                    <div>
                        <h1
                            className='text-xl md:text-2xl dark:text-white font-bold text-center'
                        >
                            {data.title1}
                        </h1>
                        <h1
                            className='text-xl md:text-2xl font-bold text-center text-red-500'
                        >
                            {data.title2}
                        </h1>
                        <div className='flex justify-center my-2 dark:text-white'>
                            <p className='text-center text-[15px] md:max-w-[700px] '>
                                {data.desc}
                            </p>
                        </div>
                    </div>
                )}

                <div className={`lg:mx-6 mt-10 pb-6 grid grid-cols-1 gap-5 ${devServices ? 'md:grid-cols-3' : 'md:grid-cols-2'}`}>
                    {data.cards.map((item, i) => (
                        <div onClick={() => handleClick(i, item.link)} className={`bg-white cursor-pointer dark:bg-slate-700 rounded-lg px-4 md:px-6 py-5 shadow-sm hover:shadow-lg hover:scale-105 duration-[1200ms] group ${sucessDriven ? 'hover:shadow-md' : 'hover:bg-red-500 dark:hover:bg-red-500'}`} key={i}>
                            {sucessDriven ? (
                                <div >
                                    <img src={item.img} alt="img" className='h-7 object-contain mb-2' />
                                </div>
                            ) : (

                                <h4 className={`font-bold text-2xl text-slate-300 ${i === 1 ? 'group-hover:text-green-500' : i === 2 ? 'group-hover:text-blue-400' : i === 3 ? 'group-hover:text-pink-300' : i === 4 ? 'group-hover:text-yellow-500' : ''} `}>
                                    0{i + 1}
                                </h4>
                            )}
                            <h1 className={`font-bold text-sm my-1 dark:text-white  ${!sucessDriven && 'group-hover:text-white'}`}>
                                {item.title}
                            </h1>
                            <p className={`text-[14px] md:text-xs dark:text-slate-300 text-slate-500 ${!sucessDriven && 'group-hover:text-white'}`}>
                                {item.desc}
                            </p>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}

export default Benefits